import { all, fork } from 'redux-saga/effects';
import { attachmentEditedEffects } from './attachment-edited';
import { initEffects } from './init';

export function* editAttachmentEffects() {
  yield all([fork(attachmentEditedEffects), fork(initEffects)]);
}
